// extracted by mini-css-extract-plugin
module.exports = {"viewport":"MUIToaster_viewport__bnTUv","toast":"MUIToaster_toast__zazkU"};